"use client"

import { useState, useEffect, useCallback } from "react"
import { ChevronLeft, ChevronRight } from "./icons"

const slides = [
  {
    id: 1,
    image: "/assets/produce5.jpg",
    title: "Fresh Produce Every Day",
    description: "Shop our wide selection of fresh fruits and vegetables",
    cta: "Shop Now",
    link: "#",
  },
  {
    id: 2,
    image: "/assets/produce8.jpg",
    title: "Summer BBQ Essentials",
    description: "Everything you need for your perfect backyard cookout",
    cta: "View Deals",
    link: "#",
  },
  {
    id: 3,
    image: "https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/487340036_1166461508557032_548157144968710274_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=2a1932&_nc_ohc=Q0_o-yx0UGwQ7kNvwGoYFHt&_nc_oc=AdkI2hWDlygpGRLwWXf-2_ORX-UWN-51AWQx2UxC17rsnaa8sRj9f-M8a4u8RgVUYGY&_nc_zt=23&_nc_ht=scontent-lga3-1.xx&_nc_gid=U5ZbJDBSvecnWVQdbscqEQ&_nc_ss=8&oh=00_AfwRmoKzPHPJJ3T78HIHMN0dJuWKayNcN-l5NfrmbDe33g&oe=69AAC431",
    title: "Organic & Local Options",
    description: "Supporting local farmers and sustainable practices",
    cta: "Learn More",
    link: "#",
  },
]

function Carousel() {
  const [currentSlide, setCurrentSlide] = useState(0)

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1))
  }, [])

  const prevSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1))
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide()
    }, 5000)

    return () => clearInterval(interval)
  }, [nextSlide])

  return (
    <div className="relative w-full overflow-hidden">
      <div
        className="flex transition-transform duration-1000 ease-out"
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {slides.map((slide) => (
          <div key={slide.id} className="relative w-full flex-shrink-0">
            <div className="relative h-[300px] md:h-[400px] lg:h-[550px] w-full">
              <img src={slide.image || "/placeholder.svg"} alt={slide.title} className="h-full w-full object-cover" />
              <div className="absolute inset-0 bg-black/30" />
            </div>
          </div>
        ))}
      </div>

      <button
        className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 rounded-full p-2 hover:bg-white"
        onClick={prevSlide}
      >
        <ChevronLeft className="h-6 w-6" />
        <span className="sr-only">Previous slide</span>
      </button>

      <button
        className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 rounded-full p-2 hover:bg-white"
        onClick={nextSlide}
      >
        <ChevronRight className="h-6 w-6" />
        <span className="sr-only">Next slide</span>
      </button>

      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`h-2 w-2 rounded-full ${currentSlide === index ? "bg-white" : "bg-white/50"}`}
            onClick={() => setCurrentSlide(index)}
          >
            <span className="sr-only">Go to slide {index + 1}</span>
          </button>
        ))}
      </div>
    </div>
  )
}

export default Carousel
